"use client";
import React, { useState, useMemo } from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import categoriesData from "../../utils/categories.json"
import { useLocalizedPath } from '../../hooks/useLocalizedPath';
import styles from './CategoriesSection.module.css';

export const CategoriesSection = () => {
    const t = useTranslations('categories');
    const tHome = useTranslations('homepage.categories');
    const tCommon = useTranslations('common');
    const { localizeFullPath } = useLocalizedPath();
    const [showAll, setShowAll] = useState(false)

    const categoriesToShow = useMemo(
        () => showAll ? categoriesData : categoriesData.slice(0, 6),
        [showAll]
    )
    const hasMoreCategories = categoriesData.length > 6

    return (
        <div className={styles.categoriesContainer}>
            <h2 className={styles.categoryTitle}>{tHome('title')}</h2>
            <p className={styles.categoryMeta}>
                {tHome('meta')}
            </p>

            <div className={styles.categoryGrid}>
                {categoriesToShow.map((category, index) => {
                    const color = category.Color || "var(--color-text-muted)";
                    return (
                        <Link
                            key={category.Slug}
                            href={localizeFullPath(`/giftcards/${category.Slug}`)}
                            prefetch={false}
                            className={styles.categoryCard}
                            style={{
                                animationDelay: `${index * 0.1}s`,
                                // @ts-expect-error CSS custom property
                                '--card-color': color,
                            }}
                        >
                            <div
                                className={styles.categoryIcon}
                                style={{ background: `linear-gradient(135deg, ${color}15, ${color}25)` }}
                            >
                                {category.Icon || "🎁"}
                            </div>
                            <h3 className={styles.categoryName}>{t(`${category.Slug}.name`)}</h3>
                            <span className={styles.categorySlug}>
                                {category.Slug}
                            </span>
                        </Link>
                    );
                })}
            </div>

            {hasMoreCategories && (
                <div className={styles.seeMoreContainer}>
                    <button className={styles.seeMoreButton} onClick={() => setShowAll(!showAll)}>
                        {showAll ? tCommon('buttons.showLess') : `${tCommon('buttons.seeMore')} (${categoriesData.length - 6} more)`}
                    </button>
                </div>
            )}
        </div>
    )
}
